import RegisterForShopRequestModelBase from '../_generated/modelBases/register-for-shop-request-model-base';

export default class RegisterForShopRequestModel extends RegisterForShopRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
